import { managePageFilters } from '../../../utils/urlUtil'
import { FilterValuesData } from '../filters'
import React, { useState } from 'react'
import { X as IconX } from 'phosphor-react'
import { Button } from 'semantic-ui-react'
import { useIntl } from 'react-intl'

interface IProps {
  pageName: string
  filters: Array<{ key: string; value: string | number | boolean | undefined }>
  filterValuesData?: FilterValuesData[]
}

const SelectedFiltersControl = (props: IProps): React.ReactElement => {
  const { pageName, filters, filterValuesData = [] } = props

  const intl = useIntl()

  const removeFilter = (key, value) => {
    managePageFilters({
      pageName: pageName,
      filterKey: key,
      filterValues: [value],
      action: 'remove'
    })
  }

  const [showAll, setShowAll] = useState(false)
  const handleShowAll = () => setShowAll(true)

  const MAX_FILTERS = 4
  const filtersSlice = showAll ? filters : filters.slice(0, MAX_FILTERS)
  const restCount = filters.length > MAX_FILTERS ? filters.length - MAX_FILTERS : 0
  const restText = `${restCount} ${intl.formatMessage({ id: 'filters.moreFilters' })}`

  return (
    <div className="selected-filters-control" data-test-id="filters-selected-filters-control">
      {filtersSlice.map(({ key, value }, i) => {
        const handleRemoveFilter = () => removeFilter(key, value)
        let name = value
        filterValuesData.find((option) => {
          if (option.key === value) {
            name = option.name
            return true
          }
          const foundGroup = option.groups?.find((gr) => gr.groupId === value)
          if (foundGroup) {
            name = foundGroup?.groupName
            return true
          }
          return false
        })

        return (
          <div key={i} className="item">
            <div className="filter truncate" title={name as string}>
              {name}
            </div>
            <Button className="button-remove-filter" onClick={handleRemoveFilter}>
              <IconX size={12} color="var(--color-river-bed)" />
            </Button>
          </div>
        )
      })}
      {!!restCount && !showAll && (
        <button className="btn item show-all" onClick={handleShowAll}>
          <div className="filter truncate" title={restText}>
            {restText}
          </div>
        </button>
      )}
    </div>
  )
}

export default SelectedFiltersControl
